import { Route } from '@angular/router';
import { UserService } from '../api/services/user.service';
import { ClientListComponent } from './components/client-list/client-list.component';

export default [
  {
    path: '',
    title: 'Te Llevo-Dashboard',
    component: ClientListComponent,
    providers: [UserService],
  },
] as Route[];